<input
  #searchInput
  type="text"
  payee-input
  [value]="displayText()"
  [disabled]="disabled"
  [matAutocomplete]="auto"
  [placeholder]="placeholder()"
  [attr.aria-label]="ariaLabel() || placeholder() || null"
  (focus)="onFocus()"
  (input)="onInput($event)"
/>
@if (showClear() && !disabled) {
  <button
    payee-suffix
    payee-icon-button
    type="button"
    color="custom"
    aria-label="Clear"
    (mousedown)="clear($event)"
  >
    <payee-icon
      name="cross-black"
      width="16"
      height="16"
    ></payee-icon>
  </button>
}
<ng-template
  #defaultOptionTemplate
  let-option
>
  {{ displayWith()(option) }}
</ng-template>
<mat-autocomplete
  #auto="matAutocomplete"
  panelClass="payee-autocomplete-panel"
  [displayWith]="displayWith()"
  [requireSelection]="requireSelection()"
  (opened)="onOpened()"
  (closed)="onClosed()"
  (optionSelected)="optionSelected($event)"
>
  @for (option of filteredOptions(); track $index) {
    <mat-option [value]="option">
      <ng-container
        [ngTemplateOutlet]="optionTemplate() ?? defaultOptionTemplate"
        [ngTemplateOutletContext]="{ $implicit: option }"
      ></ng-container>
    </mat-option>
  } @empty {
    @if (value()) {
      <mat-option [value]="value()">
        <ng-container
          [ngTemplateOutlet]="optionTemplate() ?? defaultOptionTemplate"
          [ngTemplateOutletContext]="{ $implicit: value() }"
        ></ng-container>
      </mat-option>
    } @else {
      <mat-option disabled>
        {{ "AUTOCOMPLETE.NO_OPTIONS" | translate }}
      </mat-option>
    }
  }
</mat-autocomplete>
